import { render, staticRenderFns } from "./EditPruefungsstueckComponent.vue?vue&type=template&id=50a1e5f6&scoped=true"
import script from "./EditPruefungsstueckComponent.vue?vue&type=script&lang=js"
export * from "./EditPruefungsstueckComponent.vue?vue&type=script&lang=js"
import style0 from "./EditPruefungsstueckComponent.vue?vue&type=style&index=0&id=50a1e5f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a1e5f6",
  null
  
)

export default component.exports